export const HEXAGON_DATA = {
  101: [1.37, 78257, 558.422, 43.7],
  102: [1.33, 78163, 546.046, 42.681],
  103: [0.92, 78164, 377.291, 29.491],
  104: [0.94, 78053, 384.177, 29.986],
  105: [1.21, 77980, 472.11, 36.815],
  106: [1.19, 77891, 468.235, 36.471],
  107: [1.05, 77777, 420.153, 32.678],
  108: [1.08, 77650, 431.042, 33.467],
};

export const POINT_TYPES = [
  { key: "circle_point", shape: "circle" },
  { key: "diamond_point", shape: "diamond" },
  { key: "square_point", shape: "square" },
];

export const COLOR_MAP = {
  green: "rgb(16, 185, 129)",
  verde: "rgb(16, 185, 129)",
  orange: "rgb(253, 224, 71)",
  orangehover: "rgb(249, 115, 22)",
  amarillo: "rgb(244, 193, 43)",
  red: "rgb(185, 28, 28)",
  rojo: "rgb(185, 28, 28)",
  default: "rgb(74, 144, 226)",
};

export const DENSITY_COLORS = {
  getDensityColor: (density) => {
    if (density >= 1.3) return "#3EA58A";
    if (density >= 1.15) return "#B7D357";
    if (density >= 1.0) return "#F4C12B";
    return "#E25D37";
  },
};

export const COLOR_BUTTONS_MAP_SPED_ORIGINAL = {
  primary: 'rgb(61, 69, 95)',
}
